import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-discover-payment',
  standalone: true,
  templateUrl: '../../assets/discover-payment.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamDiscoverPaymentIcon {}
